import { useMemo } from "react";
import useCloudinaryData from "../../../Common/hooks/useCloudinaryData";
import {
  getConstructorHexViewImage,
  getDriverHexViewImage,
} from "../../../Common/utils/cloudinary";
import Media from "../../media";

const HexViewImage = ({ player }) => {
  const { configData, currentSeasonYear } = useCloudinaryData();

  const playerImage = useMemo(() => {
    if (player?.PositionName === "DRIVER") {
      return getDriverHexViewImage(player, currentSeasonYear, configData);
    } else if (player?.PositionName === "CONSTRUCTOR") {
      return getConstructorHexViewImage(player, currentSeasonYear, configData);
    } else {
      return null;
    }
  }, [configData, currentSeasonYear, player]);

  return (
    <Media imgSrc={playerImage} imgAlt={player?.FUllName} />
    // <img
    //   src={playerImage}
    //   alt={player?.FUllName}
    //   onError={({ currentTarget }) => {
    //     currentTarget.onerror = null; // prevents looping
    //     currentTarget.src = `${CLOUDINARY_IMAGE_BASE_URL}common/fallback.svg?v=${IMAGE_VERSION}`;
    //   }}
    //   loading="lazy"
    // />
  );
};

export default HexViewImage;
